import { Modal } from 'antd'
import {
  UPLOAD_DUPLICATE_COPY,
  findStrongLibraryDuplicateForUpload,
} from 'src/utils/invoiceUploadDuplicateHelpers'

/**
 * Chunk U4 — soft duplicate warn before confirming a focus card file.
 * @returns {Promise<'continue'|'use_existing'|'abort'>}
 */
export function promptUploadDuplicateWarn({
  uploadFile,
  libraryInvoices = [],
} = {}) {
  const hit = findStrongLibraryDuplicateForUpload({
    uploadFiles: uploadFile ? [uploadFile] : [],
    libraryInvoices,
    excludeInvoiceIds: uploadFile?.invoiceId ? [uploadFile.invoiceId] : [],
  })

  if (!hit) {
    return Promise.resolve('continue')
  }

  const supplierTitle =
    hit.existingInvoice?.supplierTitle || hit.uploadFile?.supplierTitle || ''

  return new Promise(resolve => {
    Modal.confirm({
      title: UPLOAD_DUPLICATE_COPY.title,
      content: UPLOAD_DUPLICATE_COPY.body(hit.invoiceNumber, supplierTitle),
      okText: UPLOAD_DUPLICATE_COPY.continueOk,
      cancelText: UPLOAD_DUPLICATE_COPY.useExisting,
      centered: true,
      onOk: () => resolve('continue'),
      onCancel: () => resolve('use_existing'),
    })
  })
}

export default promptUploadDuplicateWarn
